import { render, staticRenderFns } from "./EditCollectionProducts.vue?vue&type=template&id=090abd26&scoped=true&"
import script from "./EditCollectionProducts.vue?vue&type=script&lang=ts&"
export * from "./EditCollectionProducts.vue?vue&type=script&lang=ts&"
import style0 from "./EditCollectionProducts.vue?vue&type=style&index=0&id=090abd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090abd26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VIcon,VSpacer})
